import "./ABFeatureTogglePage.scss";
import "@mshop-ui/core-web-components/dist/ui-button";
import React from "react";
import { Panel, PanelContent, PanelFooter, PanelHeader } from "@metro-ui/core";
import FeatureSessionStore, { Features, FeatureActions } from "../uidispatcherapi/FeatureSessionStore";

class ABFeatureTogglePage extends React.Component<
	Record<string, never>,
	{
		abFeatureGroups: Record<string, string>;
	}
> {
	constructor(props) {
		super(props);
		this.state = {
			abFeatureGroups: FeatureSessionStore.getGroupMemberships(),
		};
	}

	componentDidMount() {
		this.unmountFeatureSessionStore = FeatureSessionStore.listen(s => this.onUpdate(s));
	}

	componentWillUnmount() {
		this.unmountFeatureSessionStore();
	}

	unmountFeatureSessionStore() {}

	onUpdate(newState: Record<string, string>) {
		this.setState({
			abFeatureGroups: newState,
		});
	}

	onSetGroup(group: string, membership: string) {
		FeatureActions.setMembership(group, membership);
	}

	renderToggleButton(group: string, membership: string, selectedMembership: string): React.ReactNode {
		const selected = membership === selectedMembership;
		return (
			<ui-button>
				<button data-variant={selected ? "action" : ""} onClick={() => this.onSetGroup(group, membership)}>
					{membership}
				</button>
			</ui-button>
		);
	}

	renderFeatureGroupToggle(group: string, membership: string) {
		const title = <h3>{group}</h3>;
		const description = Features[group].description ? Features[group].description : <em>(description missing)</em>;
		const selection = Features[group]["description" + membership] ? (
			Features[group]["description" + membership]
		) : (
			<em>(no selection)</em>
		);
		return (
			<Panel className="feature-toggle-panel" key={group} overflowHidden>
				<PanelHeader padding="medium">{title}</PanelHeader>
				<PanelContent padding="medium">{description}</PanelContent>
				<PanelFooter padding="medium" gap="small" align="center">
					{this.renderToggleButton(group, "A", membership)}
					{this.renderToggleButton(group, "B", membership)}
					{selection}
				</PanelFooter>
			</Panel>
		);
	}

	render(): any {
		return (
			<div>
				<div className="mfcss_pageheader">
					<h1>Feature toggling and AB Testing</h1>
				</div>
				<div className="platform-feature-toggle-page">
					{Object.entries(this.state.abFeatureGroups).map(([group, membership]) =>
						this.renderFeatureGroupToggle(group, membership),
					)}
				</div>
			</div>
		);
	}
}

export default ABFeatureTogglePage;
